import React, { useEffect, useRef, useState } from "react";
import "./MomentsCreditsBanner.css";

const POSITIONS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

const MomentsCreditsBanner = ({ amount, autoPlayDelay = 0 }) => {
  const [playing, setPlaying] = useState(false);
  const [displayed, setDisplayed] = useState(0);
  const rafRef = useRef(null);

  useEffect(() => {
    if (!amount || amount <= 0) return undefined;
    const t = setTimeout(() => setPlaying(true), autoPlayDelay);
    return () => clearTimeout(t);
  }, [amount, autoPlayDelay]);

  useEffect(() => {
    if (!playing) return undefined;
    const target = amount;
    const duration = 1700;
    const startDelay = 400;
    const start = performance.now() + startDelay;

    const tick = (now) => {
      const t = Math.max(0, Math.min(1, (now - start) / duration));
      const eased = 1 - Math.pow(1 - t, 4);
      setDisplayed(eased * target);
      if (t < 1) rafRef.current = requestAnimationFrame(tick);
    };

    rafRef.current = requestAnimationFrame(tick);
    return () => {
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [playing, amount]);

  if (!amount || amount <= 0) return null;

  return (
    <div className={`mcb${playing ? " play" : ""}`}>
      <img
        className="mcb-mascot"
        src="/assets/images/blends-moments-mascot.svg"
        alt="Moments+"
      />
      <span className="mcb-text">
        בהזמנה זו קיבלת{" "}
        <strong>
          {displayed.toFixed(2)} נקודות
        </strong>{" "}
        <span className="mcb-brand">Moments+</span>
        <br />
        הצבירה זמינה למימוש בהזמנות הבאות
      </span>

      {POSITIONS.map((p) => (
        <span key={`b1-${p}`} className={`mcb-confetti b1 p${p}`} />
      ))}
      {POSITIONS.map((p) => (
        <span key={`b2-${p}`} className={`mcb-confetti b2 p${p}`} />
      ))}
      <span className="mcb-sheen" />
    </div>
  );
};

export default MomentsCreditsBanner;
